import { render, staticRenderFns } from "./ElTableWrap.vue?vue&type=template&id=15dd4aa4&"
import script from "./ElTableWrap.vue?vue&type=script&lang=js&"
export * from "./ElTableWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports